import LocationCityOutlinedIcon from "@mui/icons-material/LocationCityOutlined";
import { FormattedMessage, useIntl } from "react-intl";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import BusinessIcon from "@mui/icons-material/Business";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import ListIcon from "@mui/icons-material/List";
import SpeakerNotesOffIcon from "@mui/icons-material/SpeakerNotesOff";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";
import MoneyOffIcon from "@mui/icons-material/MoneyOff";
import SearchIcon from "@mui/icons-material/Search";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import MarkChatUnreadIcon from "@mui/icons-material/MarkChatUnread";
import FeedbackIcon from "@mui/icons-material/Feedback";
import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
const useCompanyItem = () => {
  const icons = {
    LocationCityOutlinedIcon,
    BusinessIcon,
    PeopleAltIcon,
    AccountBalanceIcon,
    ListIcon,
    SpeakerNotesOffIcon,
    DoNotDisturbIcon,
    MoneyOffIcon,
    SearchIcon,
    CalendarTodayIcon,
    ChatBubbleOutlineIcon,
    MarkChatUnreadIcon,
    FeedbackIcon,
    ReportGmailerrorredIcon,
    SettingsSuggestIcon,
  };

  const companyItems = {
    id: "group-countrie",
    title: (
      <FormattedMessage id="Companies Management">
        {(text) => (
          <span style={{ fontSize: "14px", fontWeight: "normal" }}>{text}</span>
        )}
      </FormattedMessage>
    ),
    type: "group",
    icon: icons.ListIcon,
    // url: "/companies-list",

    children: [
      {
        id: "companies-list",
        title: <FormattedMessage id="Companies List" />,
        type: "item",
        url: "/companies-list",
        icon: icons.BusinessIcon,
        breadcrumbs: false,
      },
      {
        id: "clientcompanieslist",
        title: <FormattedMessage id="Clients Companies" />,
        type: "item",
        url: "/companies-list?client=YES",
        icon: icons.ListIcon,
        breadcrumbs: false,
      },
      {
        id: "notclientcompanieslist",
        title: <FormattedMessage id="Not Clients Companies" />,
        type: "item",
        url: "/companies-list?client=NO",
        icon: icons.SpeakerNotesOffIcon,
        breadcrumbs: false,
      },
      {
        id: "undefinedcompanieslist",
        title: <FormattedMessage id="None Companies List" />,
        type: "item",
        url: "/companies-list?client=UNDEFINED",
        icon: icons.DoNotDisturbIcon,
        breadcrumbs: false,
      },
      {
        id: "freecompanieslist",
        title: <FormattedMessage id="Free Companies" />,
        type: "item",
        url: "/companies-list?client=FREE",
        icon: icons.MoneyOffIcon,
        breadcrumbs: false,
      },
      {
        id: "companiessearch",
        title: <FormattedMessage id="Companies Search" />,
        type: "item",
        url: "/search-companies",
        icon: icons.SearchIcon,
        breadcrumbs: false,
      },

      {
        id: "companiesloggedtoday",
        title: <FormattedMessage id="Companies Logged Today" />,
        type: "item",
        url: "/companies-list?last_sign_in=today",
        icon: icons.CalendarTodayIcon,
        breadcrumbs: false,
      },
      {
        id: "companiesloggedthroughtheweek",
        title: <FormattedMessage id="Companies Logged This Week" />,
        type: "item",
        url: "/companies-list?last_sign_in=week",
        icon: icons.CalendarTodayIcon,
        breadcrumbs: false,
      },
      // {
      //   id: "suggestedcompanies",
      //   title: <FormattedMessage id="Suggested Companies" />,
      //   type: "item",
      //   url: "/suggested-companies",
      //   icon: icons.SettingsSuggestIcon,
      //   breadcrumbs: false,
      // },
      /*
      {
        id: "servicepersons",
        title: <FormattedMessage id="servicepersons" />,
        type: "item",
        url: "/service-persons",
        icon: icons.FeedbackIcon,
        breadcrumbs: false,
      },

      {
        id: "companiesdescription",
        title: <FormattedMessage id="companiesdescription" />,
        type: "item",
        url: "/companies-description",
        icon: icons.LocationCityOutlinedIcon,
        breadcrumbs: false,
      },
      */
      {
        id: "companiesreplies",
        title: <FormattedMessage id="Companies Replies" />,
        type: "item",
        url: "/companies-replies",
        icon: icons.MarkChatUnreadIcon,
        breadcrumbs: false,
      },
      {
        id: "companiesreports",
        title: <FormattedMessage id="Companies Reports" />,
        type: "item",
        url: "/companies-reports",
        icon: icons.ReportGmailerrorredIcon,
        breadcrumbs: false,
      },
      {
        id: "commentsofcompanyprofile",
        title: <FormattedMessage id="Comments of Company Profile" />,
        type: "item",
        url: "/companies-comments",
        icon: icons.ChatBubbleOutlineIcon,
        breadcrumbs: false,
      },
    ],
  };

  return companyItems;
};

export default useCompanyItem;
